import React from 'react';
import PropTypes from 'prop-types';

import FaoLogo from '../FaoLogo';

import styles from './styles.module.scss';

const untranslatedLangsInstDb = ['العربية', '中文', 'Русский'];

const Header = ({ location }) => (
  <React.Fragment>
    <div className={styles.header}>
      <div className={styles.contentWrapper}>
        <a
          href="http://www.fao.org/home/zh/"
          className={styles.logo}
        >
          <FaoLogo />
        </a>

        <div className={styles.rightContent}>
          <form action="http://www.fao.org/search/zh/" method="get" target="_self" className={styles.searchForm}>
            <input name="q" type="text" className={styles.searchInput} size="18" required placeholder="自定义搜索" />
            <input name="siteurl" type="hidden" value={location.pathname} />
            <button className={styles.searchButton} type="submit">提交</button>
          </form>
        </div>
      </div>
    </div>
    <div className={styles.langPickerWrapper}>
      <ul className={styles.langPicker}>
        {(typeof window !== 'undefined') && [
          [`${window.location.pathname.replace('/aquastat/zh/', '/aquastat/ar/')}`, 'العربية'],
          [null, '中文'],
          [`${window.location.pathname.replace('/aquastat/zh/', '/aquastat/en/')}`, 'English'],
          [`${window.location.pathname.replace('/aquastat/zh/', '/aquastat/fr/')}`, 'Français'],
          [`${window.location.pathname.replace('/aquastat/zh/', '/aquastat/ru/')}`, 'Русский'],
          [`${window.location.pathname.replace('/aquastat/zh/', '/aquastat/es/')}`, 'Español'],
        ].map(([url, lang]) => {
          if (!url) {
            return <li key={lang}>{lang}</li>;
          }

          const isInstDbPage = window.location.pathname.includes('/institutions-database');
          return ((!isInstDbPage || (isInstDbPage && !untranslatedLangsInstDb.includes(lang))) && (<li key={lang}><a href={url}>{lang}</a></li>));
        })}
      </ul>
    </div>
  </React.Fragment>
);

Header.propTypes = {
  location: PropTypes.object.isRequired,
};

export default Header;
